/* Scheduler / background-jobs admin panel — extracted from Admin.jsx tech-debt split. */
import { useEffect, useState } from "react";
import { useAuth } from "@/contexts/AuthContext";
import { toast } from "sonner";
import api from "@/lib/api";
import { Clock as ClockIcon, ArrowsClockwise } from "@phosphor-icons/react";

export default function SchedulerPanel() {
  const { user } = useAuth();
  const [scheduler, setScheduler] = useState(null);

  const reload = () =>
    api.get("/admin/scheduler/status").then((r) => setScheduler(r.data)).catch(() => {});
  useEffect(() => { reload(); }, []);

  return (
    <div className="card-recipe">
      <div className="flex items-center gap-3 mb-5">
        <ClockIcon size={28} weight="duotone" className="text-rf-orange" />
        <h2 className="font-display text-2xl font-black text-rf-ink">Background jobs</h2>
        <button onClick={reload} className="ml-auto text-rf-ink-soft hover:text-rf-orange"><ArrowsClockwise size={18} /></button>
      </div>
      {scheduler ? (
        <>
          <p className="text-sm text-rf-ink-soft mb-4">Status: <span className={`font-bold ${scheduler.running ? "text-green-700" : "text-red-600"}`}>{scheduler.running ? "Running" : "Stopped"}</span></p>
          <div className="space-y-3">
            {scheduler.jobs?.map((j) => (
              <div key={j.id} className="bg-rf-cream-alt rounded-xl p-4">
                <p className="font-bold text-rf-ink">{j.name}</p>
                <p className="text-xs text-rf-ink-soft font-mono">{j.trigger}</p>
                <p className="text-xs text-rf-orange mt-1">Next run: {j.next_run ? new Date(j.next_run).toLocaleString() : "—"}</p>
              </div>
            ))}
          </div>
          {user?.role === "SuperAdmin" && (
            <div className="flex flex-wrap gap-3 mt-5">
              <button
                data-testid="admin-run-archive-cleanup"
                onClick={async () => {
                  const { data } = await api.post("/admin/run-archive-cleanup");
                  toast.success(`Cleanup ran: ${data.deleted || 0} accounts removed`);
                }}
                className="btn-outline-ink !py-2.5 !px-4 !text-sm"
              >Run archive cleanup now</button>
              <button
                data-testid="admin-cleanup-broken-images"
                onClick={async () => {
                  if (!window.confirm("HEAD-check every recipe image URL and strip the dead ones? This may take a minute or two on a large database.")) return;
                  toast.info("Scanning… this can take a minute.", { duration: 4000 });
                  try {
                    const { data } = await api.post("/admin/cleanup-broken-images");
                    toast.success(
                      `Scanned ${data.scanned} recipes — removed ${data.urls_removed} dead image URL${data.urls_removed === 1 ? "" : "s"} across ${data.cleaned_recipes} recipe${data.cleaned_recipes === 1 ? "" : "s"}.`,
                      { duration: 8000 },
                    );
                  } catch (e) {
                    toast.error(e?.response?.data?.detail || "Cleanup failed.");
                  }
                }}
                className="btn-outline-ink !py-2.5 !px-4 !text-sm"
                title="Strip expired Instagram/TikTok/Pinterest image URLs from all recipes"
              >Clean up broken recipe images</button>
            </div>
          )}
        </>
      ) : <p className="text-rf-ink-soft">Loading scheduler status…</p>}
    </div>
  );
}
